import { Link } from "react-router-dom"
import { useTranslation } from "../hooks/useTranslation";

export default function NotFound() {
    const t = useTranslation();
    return (
        <div className="analytics-container text-center">
            <h1>{t('Sorry, the page you were looking for was not found.')}</h1>
            <Link to="/" className="link-button">{t('Return to Home')}</Link>
        </div>
    )
}
